import {Page} from '@vio/core/src/analytics/types/Events'
import {BrandCode} from '@vio/core/src/brand/types'

import {organizationMicrodata, websiteMicrodata} from './vioStructuredData'

const structuredDataMap: Partial<
  Record<BrandCode, Partial<Record<Page, string[]>>>
> = {
  vio: {
    [Page.Home]: [
      JSON.stringify(organizationMicrodata),
      JSON.stringify(websiteMicrodata)
    ]
  }
}

export const getStructuredData = (brandCode: BrandCode, page?: Page) => {
  if (!page) {
    return []
  }

  const structuredData = structuredDataMap[brandCode]?.[page]

  return structuredData ?? []
}
